import GaryLogin from './garyLogin.vue';
import { createApp } from 'vue';
import { STORAGE_TOKEN_KEY } from '@os-web/const';
import { ref } from 'vue';
// 全局弹窗实例
let compInts = null;

// 创建组件实例
function createLogin(options, resolve) {
  if (compInts?.instance) compInts.destroy();

  const loginShow = options?.loginShow ?? true;
  const vNode = createApp(GaryLogin, {
    loginShow,
    ...options,
    onClose: close,
    onLogin: resolve,
  });
  const root = document.createElement('div');
  document.body.appendChild(root);
  const curCompInts = {
    instance: vNode.mount(root),
    destroy,
    close,
  };

  function destroy() {
    if (!compInts?.instance) return;
    vNode.unmount();
    document.body.removeChild(root);
    compInts = null;
  }

  function close() {
    setTimeout(() => {
      destroy();
    }, 1000);
  }

  return curCompInts;
}

export function closeLogin() {
  if (compInts?.instance) {
    compInts.instance.closeLogin();
  }
}
export const otherParams = ref({});
// 直接打开登录弹窗
export const showLogin = (options, params, resolve) => {
  otherParams.value = params;
  compInts = createLogin(options, resolve);

  return compInts;
};
export async function isLogin(options, otherParams) {
  return new Promise((resolve) => {
    const loginToken = localStorage.getItem(STORAGE_TOKEN_KEY);
    if (loginToken) return resolve();
    return showLogin(options, otherParams, resolve);
  });
}

export { GaryLogin };
